import appSettings from '@assets/settings/app-settings.json';

export const environment = {
    dev: false,
    production: true,

    defaultApiVersion: 'v1.0',
    baseUrl: '',

    commonDefaultApiVersion: '',
    commonBaseUrl: 'v1.0',
    dsmBaseUrl:'',
    commonLoginPortalUrl: '',
    ipm_URL: '',
    irm_url: '',
    imsURL: '',
    cmsURL: '',
    interplanURL: '',
    urlAfterLogin: appSettings.urlAfterLogin,
    defaultErrorMessage: appSettings.messages.defaultErrorMessage,
    sessionTimeoutDuration: appSettings.sessionTimeoutDuration,
    loginAttemptsTotal: appSettings.loginAttemptsTotal,
    isPermissionOn: true,
    commonControlApiBaseUrl: '',
    commonControlAppUrl: '',
    surveyAPIUrl: '',
    surveyAppUrl: '',
    authentcationMethod: appSettings.authentcationMethod,
    numberOfTokensInPool: appSettings.numberOfTokensInPool,
    isOneTimeTokenEnabled: appSettings.isOneTimeTokenEnabled,
    isCommonLoginEnabled: appSettings.isCommonLoginEnabled,
    tokenPoolMinimumThresholdPercentage:
        appSettings.tokenPoolMinimumThresholdPercentage,
    commonActionAppUrl: '',
    commonActionApi: '',
    CammsIncidentServiceApiUrl: '',
    CammsIncidentClientUrl: '',    
    cammsServiceApiUrl: '',
    cammsServiceClientUrl: '',
    IMS_Url: '',
    administrationAppUrl: '',
    legacyApiUrl: '',
    riskAppUrl: '',
    bowTieAppUrl: '',
};

